import Phaser from 'phaser';

/**
 * 
 * @param {Phaser.Math.Vector2} vector 
 * @param {number} k 
 * @param {Phaser.Math.Vector2} displ 
 */
function spring (vector, k,displ) {
  vector.set(displ.x * -k, displ.y * -k);
}

/**
 * 
 * @param {number} c 
 * @param {Phaser.Math.Vector2} vel 
 * @param {Phaser.Math.Vector2} vector 
 */
function damping (c, vel, vector) {
  const velMag = vel.distance(Phaser.Math.Vector2.ZERO);
  if (velMag > 0) {
    vector.set(vel.x, vel.y);
    vector.multiply({ x: -c, y: -c });
  }
  else {
    vector.reset();
  }
}

/**
 * 
 * @param {Phaser.Math.Vector2[]} arr 
 * @param {Phaser.Math.Vector2} vector 
 */
function add (arr, vector) {
  vector.reset();
  for (let i = 0; i < arr.length; i++) {
    const force = arr[i];
    vector.add(force);
  }
}

export default {
  spring,
  damping,
  add
};